import type en from "../en/languages";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  title: "اللغات",
  description: "بِع بأكثر من لغة. لغة لوحة التحكم تُضبط بشكل منفصل من الشريط العلوي؛ أما هنا فهي اللغات التي يقرأ بها عملاؤك متجرك.",
  storefrontLanguages: "لغات واجهة المتجر",
  storefrontLanguagesHint: "اللغة الافتراضية هي اللغة التي كُتب بها محتواك. تبقى اللغات الإضافية مخفية عن العملاء حتى تنشرها.",
  addLanguage: "إضافة لغة",
  default: "افتراضية",
  publishedBadge: "منشورة",
  hiddenBadge: "مخفية عن العملاء",
  preview: "معاينة ↗",
  manageTranslations: "الترجمات",
  noneYet: "لا توجد لغات إضافية بعد. أضف لغة لبدء ترجمة متجرك.",
  enabled: "تمت إضافة اللغة. ستبقى مخفية حتى تنشرها.",
  removed: "تمت إزالة اللغة.",
  publish: "نشر",
  unpublish: "إلغاء النشر",
  publishTitle: "نشر {language}؟",
  publishBody: "سيتمكن العملاء من التبديل إلى هذه اللغة. ستُنشر كل مسودات ترجماتها، وسيظهر النص غير المترجم بلغتك الافتراضية.",
  unpublishTitle: "إخفاء {language}؟",
  unpublishBody: "لن يرى العملاء هذه اللغة بعد الآن. سيتم الاحتفاظ بالترجمات.",
  removeTitle: "إزالة {language}؟",
  removeBody: "سيتم حذف اللغة وجميع ترجماتها.",
  publishedMsg: "تم نشر اللغة.",
  unpublishedMsg: "تم إخفاء اللغة عن العملاء.",
  translationsFor: "ترجمات {language}",
  completeness: "نسبة النص المترجم في متجرك: {percent}%.",
  completenessLabel: "نسبة اكتمال الترجمة",
  hiddenNote: "هذه اللغة مخفية عن العملاء. تحقق منها عبر المعاينة ثم انشرها عندما تكون جاهزًا.",
  colContent: "المحتوى",
  colStatus: "الحالة",
  colProgress: "الحقول",
  status_missing: "غير مترجم",
  status_partial: "مترجم جزئيًا",
  status_complete: "مترجم",
  status_outdated: "بحاجة إلى تحديث",
  unpublishedChanges: "تغييرات غير منشورة",
  machineTranslated: "ترجمة بالذكاء الاصطناعي",
  edit: "تعديل",
  type_store: "المتجر",
  type_page: "صفحة",
  type_menu: "قائمة",
  type_collection: "مجموعة",
  type_product: "منتج",
  aiTranslateMissing: "ترجمة الناقص بالذكاء الاصطناعي",
  aiTranslateThis: "ترجمة بالذكاء الاصطناعي",
  aiWorking: "جارٍ الترجمة…",
  aiUnavailable: "الترجمة بالذكاء الاصطناعي غير مُعدّة على هذا الخادم.",
  aiDone: "عدد العناصر المترجمة كمسودات: {count}. راجعها قبل النشر.",
  aiDone_one: "تمت ترجمة عنصر واحد كمسودة. راجعه قبل النشر.",
  editorHint: "الترجمة من {from} إلى {to}. الأسعار ورموز المنتجات والصور والروابط تؤخذ دائمًا من الأصل.",
  outdatedNote: "تغيّر النص الأصلي بعد هذه الترجمة. تحقق من الحقول أدناه.",
  field_title: "العنوان",
  field_description: "الوصف",
  field_seoTitle: "عنوان محركات البحث",
  field_seoDescription: "وصف محركات البحث",
  field_menuLabel: "اسم عنصر القائمة",
  field_section: "قسم",
  saveDraft: "حفظ المسودة",
  savedDraft: "تم حفظ الترجمة كمسودة.",
  publishThis: "نشر هذه الترجمة",
  aiRemaining: "عدد العناصر المتبقية للترجمة: {count} — انقر مرة أخرى للمتابعة.",
  translationPublished: "تم نشر الترجمة.",
};

export default ar;
